export default "__VITE_ASSET__dQpCWxi5__"